import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../../api/analyticsApi';
import { analyticsKeys } from './analyticsKeys';

export const useUserActivity = (startDate: string, endDate: string) =>
    useQuery({
        queryKey: analyticsKeys.userActivity(startDate, endDate),
        queryFn: () => analyticsApi.getUserActivity(startDate, endDate),
        staleTime: 5 * 60 * 1000,
    });

export const useRetention = (startDate: string, endDate: string, segment: string) =>
    useQuery({
        queryKey: analyticsKeys.retention(startDate, endDate, segment),
        queryFn: () => analyticsApi.getRetention(startDate, endDate, segment),
        staleTime: 5 * 60 * 1000,
    });
